var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M314 299h17l106 106-32 32-106-106v-17l-6-6q-37 33-90 33-58 0-98-40-41-41-41-98 0-58 41-99 40-40 98-40t98 40 40 99q0 53-33 90zm-179-28q28 28 68 28t68-28 28-68-28-68-68-28-68 28-28 68 28 68"
  })));
};
export default SvgSearch;